import React from 'react';

interface Props {
  quoteIntegrative?: { anno: number }[] | null;
  isPrincipal?: boolean;
  anno?: number; // default: anno corrente
}

/**
 * Badge dello stato pagamento di una SEDE SECONDARIA per l'anno corrente:
 * verde "Pagata <anno>" se quoteIntegrative contiene l'anno, altrimenti grigio "Non pagata".
 * Per le sedi principali non ha senso (la principale è l'Associate) → non rende nulla.
 */
const SedePagamentoBadge: React.FC<Props> = ({ quoteIntegrative, isPrincipal, anno }) => {
  if (isPrincipal) return null;
  const y = anno ?? new Date().getFullYear();
  const pagata = Array.isArray(quoteIntegrative) && quoteIntegrative.some(q => q.anno === y);
  return pagata ? (
    <span className="inline-flex items-center text-2xs px-1.5 py-0.5 rounded bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300 font-medium">
      Pagata {y}
    </span>
  ) : (
    <span className="inline-flex items-center text-2xs px-1.5 py-0.5 rounded bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400 font-medium">
      Non pagata
    </span>
  );
};

export default SedePagamentoBadge;
